<div class="">
    <app-spinner></app-spinner>
    <div class="container-fluid fixed-top ">
        <app-header></app-header>
    </div>

    <div class="container-fluid py-5 mt-5 margin-top-5" id="top-page">

        <div class="container d-flex cart-container">
            <div>
                <app-cart-options (sendChange)="setProcessView($event)"/>
            </div>
            <div class="w-100">
                @switch (indexView) {
                    @case (1) {
                        <div>
                            <app-cart-detail/>
                        </div>
                    }
                    @case (2) {
                        <div>
                            <app-cart-order-flow />
                        </div>
                        
                    }
                    @case (3) {
                        <div> 
                            <app-stepper [labels]="labels"/>
                        </div>
                        
                    }
                }

            </div>
        </div>
        
    </div>

    <div>
        <app-footer></app-footer>
    </div>
</div>

